// ======================================================================
// File Name       : CourseSortContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Modal, ListGroup, ListGroupItem } from 'react-bootstrap';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { updateDisplayOrder, saveDisplayOrder } from '../../actions/ContainerAction';
import { STRUCTURE_TYPE } from '../../constants';

class CourseSortContainer extends Component {
  constructor() {
    super();
    this.state = {};

    this.saveDisplayOrder = this.saveDisplayOrder.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.getCurrentPosOfActiveValue = this.getCurrentPosOfActiveValue.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.moveToTop = this.moveToTop.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.moveToBot = this.moveToBot.bind(this);
  }

  handleSelect(index) {
    this.setState({
      activeValue: index,
    });
  }

  getCurrentPosOfActiveValue() {
    return this.props.structureSecernIdList.indexOf(this.state.activeValue);
  }

  moveToTop() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    this.onSortEnd({
      oldIndex: this.state.activeValue,
      newIndex: 0,
    });
  }

  moveUp() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    const pos = this.state.activeValue;
    this.onSortEnd({
      oldIndex: pos,
      newIndex: pos - 1 < 0 ? 0 : pos - 1,
    });
  }

  moveDown() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    const length = this.props.structureSecernIdList.length;
    const pos = this.state.activeValue;
    this.onSortEnd({
      oldIndex: pos,
      newIndex: pos + 1 >= length ? length - 1 : pos + 1,
    });
  }

  moveToBot() {
    if (isNaN(this.state.activeValue)) {
      return;
    }
    this.onSortEnd({
      oldIndex: this.state.activeValue,
      newIndex: this.props.structureSecernIdList.length - 1,
    });
  }

  onSortEnd({ oldIndex, newIndex }) {
    const structureSecernIdList = arrayMove(this.props.structureSecernIdList, oldIndex, newIndex);
    this.setState({
      activeValue: newIndex,
    });
    const { dispatch } = this.props;
    dispatch(updateDisplayOrder(structureSecernIdList));
  }

  saveDisplayOrder() {
    const { dispatch } = this.props;
    dispatch(saveDisplayOrder());
  }

  getNodePath(secernId, fullPath) {
    if (!secernId) {
      return '';
    }
    const { structureBySecernId } = this.props;
    const { structureName, parentCourseSecernId, parentBoxSecernId } = structureBySecernId[
      secernId
    ];
    const nodePath = structureName;
    if (fullPath && (parentCourseSecernId || parentBoxSecernId)) {
      return `${this.getNodePath((parentBoxSecernId || parentCourseSecernId), fullPath)} ▶ ${nodePath}`;
    }
    return nodePath;
  }

  getModalOption() {
    const { structureType } = this.props;
    let sortTitle;
    if (structureType === STRUCTURE_TYPE.COURSE) {
      sortTitle = 'コース';
    } else if (structureType === STRUCTURE_TYPE.BOX) {
      sortTitle = 'セクション';
    } else {
      sortTitle = 'コンテンツ';
    }

    return {
      title: `${sortTitle}の並び順を変更してください`,
      footerBtns: [
        {
          name: 'キャンセル',
          onClick: this.props.hideModal,
          variant: 'default',
        },
        {
          name: 'OK',
          onClick: this.saveDisplayOrder,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const { structureSecernId, structureSecernIdList, structureBySecernId } = this.props;
    let parentCourseSecernId = null;
    let parentBoxSecernId = null;
    if (structureBySecernId && structureBySecernId[structureSecernId]) {
      parentCourseSecernId = structureBySecernId[structureSecernId].parentCourseSecernId;
      parentBoxSecernId = structureBySecernId[structureSecernId].parentBoxSecernId;
    }
    const structurePath = this.getNodePath(parentBoxSecernId || parentCourseSecernId, true);
    const self = this;
    const structureNameList = structureSecernIdList && structureSecernIdList.map((item) => {
      return self.getNodePath(item);
    });

    return (
      <ModalWrapper {...this.getModalOption()} hideModal={this.props.hideModal} bodyClassName="setMinHeight">
        <Row>
          <Col sm={12}>
            <h3>
              {structurePath}
            </h3>
          </Col>
        </Row>
        <Row className="margin-top-15">
          <Col sm={11}>
            <SortableList
              items={structureNameList}
              onSortEnd={this.onSortEnd}
              onClick={this.handleSelect}
              activeValue={this.state.activeValue}
              useDragHandle
              onBlur={event => this.setState({ activeValue: '' })}
            />
          </Col>
          <Col sm={1}>
            <div className="fixed-button-sort">
                <Button variant="primary" className="btn-text-vertical" onClick={this.moveToTop}>
                  ↑最上位
                </Button>
                <Button
                  variant="primary"
                  className="btn-text-vertical  margin-top-10"
                  style={{ height: '70px' }}
                  onClick={this.moveUp}
                >
                  ↑
                </Button>
                <Button
                  variant="primary"
                  className="btn-text-vertical  margin-top-10"
                  style={{ height: '70px' }}
                  onClick={this.moveDown}
                >
                  ↓
                </Button>
                <Button
                  variant="primary"
                  className="btn-text-vertical margin-top-10"
                  onClick={this.moveToBot}
                >
                  最下位↓
                </Button>
            </div>
          </Col>
        </Row>
      </ModalWrapper>
    );
  }
}

const DragHandle = SortableHandle(() =>
  (<span style={{ color: 'rgba(23, 23, 23, 0.58)' }}>
    <i className="bi bi-justify margin-right-15" />
  </span>),
);
const SortableItem = SortableElement(({ active, value, onClick }) =>
  (<ListGroupItem
    className="z-index-front display-table"
    onMouseDown={(event) => {
      onClick(value);
    }}
    active={active}
  >
    <DragHandle />
    <span className="break-text display-table-cell" style={{ width: '100%' }}>
      {value}
    </span>
  </ListGroupItem>),
);

const SortableList = SortableContainer(({ activeValue, items, onClick }) =>
  (<ListGroup>
    {items && items.map((value, index) =>
      (<SortableItem
        key={index}
        index={index}
        value={value}
        onClick={() => {
          onClick(index);
        }}
        active={index === activeValue}
      />),
    )}
  </ListGroup>),
);

const mapStateToProps = (state, ownProps) => {
  const {
    container: {
      editingStructure: { structureSecernId, structureSecernIdList, structureType },
      structures: { bySecernId },
    },
  } = state;
  return { structureSecernId, structureSecernIdList, structureType, structureBySecernId: bySecernId };
};

export default connect(mapStateToProps)(CourseSortContainer);
